/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-cycle */

import {
  HomefieldIconArrowRight,
  HomefieldIconSearch as SearchIcon,
  HomefieldIconSignCancel,
} from '@dsg-tech/homefield-react-icons';
import React, { ChangeEvent, useCallback, useContext, useEffect, useRef, useState } from 'react';
import { handleADA } from '@dsg-tech/homefield-utils';
import { checkStores, cleanSearchTerm } from 'utility/utility';
import { getCookie, setCookie } from 'utility/cookie-utils';
import {
  handleSAYT20CharactersEvent,
  handleSAYTEvent,
  handleTapAheadEvent,
} from 'utility/analytics-events';
import {
  searchDataSelector,
  searchInputSelector,
  searchProductInputSelector,
} from 'store/selectors/saytSelector';
import { setFirePreSaytImpression, setProductSearchInput, setSearchInput } from 'store/slices/sayt';
import { useAppDispatch, useAppSelector } from 'store/store';

import { KEY_CODES } from 'utility/constants';
import { WindowContext } from 'utility/windowContext';
import { getFeatureFlagByNameSelector } from 'store/selectors';
import useSetSearchTerm from 'hooks/useSetSearchTerm';
import { envData } from '../../../../environments';
import SearchResults from './SearchResults/SearchResults';
import SuggestionBrandsResults from './SuggestionBrandsResults/SuggestionBrandsResults';
import SuggestionCategoriesResults from './SuggestionCategoriesResults/SuggestionCategoriesResults';
import SuggestionHistoryResults from './SuggestionHistoryResults/SuggestionHistoryResults';
import SuggestionKeywordsResults from './SuggestionKeywordsResults/SuggestionKeywordsResults';
import SuggestionProductsResults from './SuggestionProductsResults/SuggestionProductsResults';
import { SearchProductResult, SearchState } from './types/index';
import './Search.scss';

/* eslint-disable react/display-name */

interface SearchProps {
  storeIdentifierName: string;
  thumbnailApi: string;
  showResult?: boolean;
  viewPortBreakpoint: string;
  mobile: boolean;
}

const searchTypeAnalyticsReference = {
  keyword: 'searchTerm',
  brand: 'brands',
  category: 'categories',
};

export default function Search({
  storeIdentifierName,
  thumbnailApi = '',
  showResult = true,
  viewPortBreakpoint,
  mobile,
}: SearchProps) {
  const dispatch = useAppDispatch();
  const win = useContext(WindowContext);
  // checking to see if window object exitst, if it does we grab the search params for use later
  const search = win && window.location ? window.location.search : '';
  // if search params exist then we setup a new URLSearchParam object
  const params = search ? new URLSearchParams(search) : null;
  // utilize the search params object to get our searchTerm that was passed from the url, or set the initial search term to an empty string

  const productSearchInput = useAppSelector(searchProductInputSelector);

  const sayt20EventFired = useRef<boolean>(false);

  const SearchInputActivatedEventEmitter = (): void => {
    const searchInputActivatedEvent = new CustomEvent('SearchInputActivated');
    document.dispatchEvent(searchInputActivatedEvent);
    dispatch(setFirePreSaytImpression(false));
  };

  const [searchHistoryResults, setsearchHistoryResults] = useState<
    SearchState['searchHistoryResults']
  >([]);

  const wrapperRef = useRef(null);
  const [showResultsDiv, setshowResultsDiv] = useState(false);

  const productsContainerRef = useRef(null);

  const saytCategoriesRouteChangeEnabled = useAppSelector(
    getFeatureFlagByNameSelector('saytCategoriesRouteChangeEnabled'),
  );

  const searchInput = useAppSelector(searchInputSelector);
  const searchData = useAppSelector(searchDataSelector);
  const [setSearchTerm] = useSetSearchTerm();
  const [displayedSearchTerm, setDisplayedSearchTerm] = useState<string>(searchInput || '');

  const setProductSearchTerm = (payload: { term: string; type: string; url: string | null }) => {
    dispatch(setProductSearchInput(payload));
  };

  const evaluateViewAllUrl = () => {
    let url;
    if (productSearchInput && productSearchInput.url) {
      url = productSearchInput.url;
    } else if (productSearchInput && productSearchInput.term) {
      url = `/search/SearchDisplay?searchTerm=${productSearchInput.term}&storeId=${envData[storeIdentifierName].storeId}&catalogId=${envData[storeIdentifierName].catalogId}&langId=-1&sType=SimpleSearch&resultCatEntryType=2&showResultsPage=true&fromPage=Search&searchSource=Q&pageView=&beginIndex=0&DSGsearchType=Keyword&pageSize=48`;
    } else if (searchData && searchData.suggestions && searchData.suggestions.keywords[0]) {
      url = `/search/SearchDisplay?searchTerm=${searchData.suggestions.keywords[0]}&storeId=${envData[storeIdentifierName].storeId}&catalogId=${envData[storeIdentifierName].catalogId}&langId=-1&sType=SimpleSearch&resultCatEntryType=2&showResultsPage=true&fromPage=Search&searchSource=Q&pageView=&beginIndex=0&DSGsearchType=Keyword&pageSize=48`;
    } else {
      url = `/search/SearchDisplay?searchTerm=${searchInput}&storeId=${envData[storeIdentifierName].storeId}&catalogId=${envData[storeIdentifierName].catalogId}&langId=-1&sType=SimpleSearch&resultCatEntryType=2&showResultsPage=true&fromPage=Search&searchSource=Q&pageView=&beginIndex=0&DSGsearchType=Keyword&pageSize=48`;
    }
    return url;
  };

  // prevents body from scrolling when search results container is present
  useEffect(() => {
    if (showResultsDiv) {
      document.body.classList.add('search-results-open');
    } else if (document.body.classList.contains('search-results-open')) {
      document.body.classList.remove('search-results-open');
    }
  }, [showResultsDiv]);

  const updateSearchTerm = (event: ChangeEvent<HTMLInputElement>) => {
    setDisplayedSearchTerm(event.target.value);
    const cleanedTerm = cleanSearchTerm(event.target.value);
    setSearchTerm(cleanedTerm);
    setsearchHistoryResults([]);

    // SAYT20Characters event and fire once per page view using the ref
    if (event.target.value.length >= 20 && !sayt20EventFired.current) {
      handleSAYT20CharactersEvent();
      sayt20EventFired.current = true;
    }

    if (event.target.value.length === 0) {
      getHistoryData();
    }
  };

  function getHistoryData() {
    let searchHistoryData = [];
    const searchTermHistoryData = decodeURIComponent(getCookie('searchTermHistory')) || '';
    if (searchTermHistoryData && searchTermHistoryData !== 'null') {
      let searchTermArray = [];
      if (searchTermHistoryData.includes('|')) {
        searchTermArray = searchTermHistoryData.split('|');
      } else if (searchTermHistoryData.includes(',')) {
        searchTermArray = searchTermHistoryData.split(',');
      } else {
        searchTermArray.push(searchTermHistoryData);
      }
      for (let i = searchTermArray.length - 1; i >= 0; i -= 1) {
        if (searchTermArray[i]) {
          searchHistoryData.push(searchTermArray[i]);
        }
      }
      searchHistoryData = Array.from(new Set(searchHistoryData));
      setsearchHistoryResults(searchHistoryData);
      if (searchHistoryResults.length > 0) {
        setshowResultsDiv(true);
      }
    }
  }

  async function searchFromSuggestion(searchString: string, type: string, url?: string) {
    setCookie(
      'searchRefinement',
      searchTypeAnalyticsReference[type] ? searchTypeAnalyticsReference[type] : type,
    );
    setProductSearchTerm({
      term: searchString,
      type,
      url: url || null,
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const inputRef = useRef<any>();
  // Removing this to fix bug TOF-2409
  // Keeping the code because when we re-visit SAYT we will be revisiting the scrollTo functionality
  // async function focusOnInput(event: any) {
  //   // Handle triggering Analytics Event for focusing search box
  //   if (viewPortBreakpoint === 'mobile') {
  //     const searchBarPosition = inputRef.current.getBoundingClientRect();
  //     const scrollTop =
  //       (typeof window !== 'undefined'  && window.pageYOffset) || document.documentElement.scrollTop;
  //     window.scrollTo(0, searchBarPosition.top + scrollTop);
  //   }
  //   handleSearchFocusEvent();
  //   updateSearchTerm(event);
  //   if (event.target.value.length >= 3 && suggestionResults) {
  //     setshowResultsDiv(true);
  //   }
  // }

  const searchKeydown = (event: React.KeyboardEvent) => {
    if (event.keyCode === KEY_CODES.ENTER && searchInput.length >= 1) {
      const str = cleanSearchTerm(searchInput);
      setCookie('enterSTerm', str);
      setCookie('sTermCookie', str);
      window.location.href = submitSearch(str, 'enterSearchTerm');
    }
    if (searchInput.length <= 2) {
      setshowResultsDiv(false);
    }
  };

  const clickSuggestedTerm = (searchType) => {
    setCookie(
      'searchRefinement',
      searchTypeAnalyticsReference[searchType]
        ? searchTypeAnalyticsReference[searchType]
        : searchType,
    );
    handleSAYTEvent(cleanSearchTerm(searchInput));
  };

  const submitSearch = (term: string, searchType: string, url?: string) => {
    if (term !== '') {
      let str: string;
      setCookie(
        'searchRefinement',
        searchTypeAnalyticsReference[searchType]
          ? searchTypeAnalyticsReference[searchType]
          : searchType,
      );

      str = term;

      if (searchType === 'brand' && typeof url !== 'undefined') {
        str = url;
      }

      if (searchType === 'enterSearchTerm') {
        setCookie('originSayT', false);
      } else {
        setCookie('originSayT', true);
      }

      str = cleanSearchTerm(term);

      if (searchType === 'category' && saytCategoriesRouteChangeEnabled) {
        return `${url}?enteredSearchTerm=${str}&SearchType=Category`;
      }

      return checkStores(`/search/SearchDisplay?${determineSuggestionHref(searchType, str)}`);
    }

    return null;
  };

  function determineSuggestionHref(searchType: string, term: string) {
    // Get the store cookie
    const storeCookie = decodeURIComponent(getCookie('setStoreCookie')) || '';

    // Parse the cookie
    const selectedStore = storeCookie.split('_')[2];
    const selectedStoreParam = selectedStore ? `&selectedStore=${selectedStore}` : '';
    const queryParams = `searchTerm=${term}&storeId=${envData[storeIdentifierName].storeId}&catalogId=${envData[storeIdentifierName].catalogId}&langId=-1&sType=SimpleSearch&resultCatEntryType=2&showResultsPage=true&fromPage=Search&searchSource=Q&pageView=&beginIndex=0&DSGsearchType=Keyword&pageSize=48${selectedStoreParam}`;

    return `${queryParams}`;
  }

  function handleClear(event?: React.KeyboardEvent) {
    if (
      (event && event.keyCode === KEY_CODES.ENTER) ||
      (event && event.keyCode === KEY_CODES.SPACE) ||
      (event && event.keyCode === KEY_CODES.ESCAPE) ||
      (event && event.type === 'click')
    ) {
      setSearchTerm('');
      setDisplayedSearchTerm('');
      setshowResultsDiv(false);
    }
  }

  function updateSearchTermSAYT(term: string) {
    // Analytics
    handleTapAheadEvent(term);

    setSearchTerm(term);
    setDisplayedSearchTerm(term);

    // Setting the Focus back on the input box
    setTimeout(() => {
      (document.querySelector('#searchInput') as HTMLInputElement)?.focus();
    }, 100);
  }

  useEffect(() => {
    if (!showResult) {
      setshowResultsDiv(showResult);
    }
  }, [showResult]);

  useEffect(() => {
    // We don't want to resultsdiv panel to show when we are setting our searchTerm off our params.
    if (
      (searchData?.suggestions && params && params.get('searchTerm') !== searchInput) ||
      (searchData?.suggestions && !params)
    ) {
      setshowResultsDiv(true);
    } else {
      setshowResultsDiv(false);
    }
  }, [searchData]);

  const toggleSticky = useCallback(() => {
    if (document.querySelectorAll('.dsg-header-search-sticky-enabled')[0]) {
      // Get client height of the filter top header used to offset the sticky of the side filter facets
      const stickyTopSortContainer = document.querySelectorAll(
        '.dsg-header-search-sticky-enabled',
      )[0].clientHeight;
      const stickyTop = document.querySelectorAll('.dsg-header-search-sticky-enabled')[0];

      // Set some other variables to hold the sticky anchor div, sticky ghost div, and the product card container
      const stickyAnchorDiv = document.querySelector('#header-search-bar-sticky-anchor');
      const stickyGhostDiv = document.querySelector('#header-search-bar-sticky-ghost-div');
      const mobileFilterButton = document.querySelectorAll(
        '.hmf-mobile-sticky-filter-toggle-button',
      )[0];

      const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;

      // When the sticky anchor div is outside the bounding client rect make the elements sticky
      if (window.innerWidth >= 1024) {
        // Case where the element should no longer be sticky we need to reset things and remove the sticky class

        // Remove the sticky class from the element
        stickyTop.classList.remove('sticky');
        // stickyTop.classList.remove('sharing-row');

        // Set the height of the ghost div back to zero to take up no height
        stickyGhostDiv.style.height = '0px';
      } else if (scrollTop >= stickyAnchorDiv.offsetTop) {
        if (mobileFilterButton && mobileFilterButton.classList.contains('sticky')) {
          // stickyTop.classList.add('sharing-row');
        } else {
          // stickyTop.classList.remove('sharing-row');
        }
        // Add the sticky class to the element
        stickyTop.classList.add('sticky');

        // Set the height of the ghost div to match the rendered height of the filter top header
        stickyGhostDiv.style.height = `${stickyTopSortContainer}px`;
      } else {
        // Case where the element should no longer be sticky we need to reset things and remove the sticky class

        // Remove the sticky class from the element
        stickyTop.classList.remove('sticky');
        // stickyTop.classList.remove('sharing-row');

        // Set the height of the ghost div back to zero to take up no height
        stickyGhostDiv.style.height = '0px';
      }
    }
  }, []);

  useEffect(() => {
    // Debounce the toggle sticky function to prevent it from firing too often or not firing on time
    const debouncedToggleSticky = () => {
      clearTimeout(window.resizeTimeout);
      window.resizeTimeout = setTimeout(() => {
        toggleSticky();
      }, 50);
    };

    document.addEventListener('click', hidesearchResults, false);
    if (
      window.location.href.includes('/f/') ||
      window.location.href.includes('/search/SearchDisplay') ||
      getCookie('stickySearch') === 'true'
    ) {
      toggleSticky();
      document.addEventListener('scroll', toggleSticky, false);
      document.addEventListener('resize', debouncedToggleSticky, false);
    }
    return function cleanup() {
      document.removeEventListener('click', hidesearchResults, false);
      if (
        window.location.href.includes('/f/') ||
        window.location.href.includes('/search/SearchDisplay') ||
        getCookie('stickySearch') === 'true'
      ) {
        document.removeEventListener('scroll', toggleSticky, false);
        document.removeEventListener('resize', debouncedToggleSticky, false);
      }
    };
  }, []);

  const hidesearchResults = (event: any) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      setshowResultsDiv(false);
    }
  };

  const getProductImage = (product: SearchProductResult) => {
    let color = '';
    if (product.color) {
      color = `_${product.color.replace(/[^\w]/gi, '_').replace(/(_+)\1+/g, '$1')}`;
    }
    const imageUrl = `${thumbnailApi + product.thumbnail + color}_is/?$DSG_ProductCard$`;
    return imageUrl;
  };

  const searchInputJsx = (
    <div className="hmf-pl-m hmf-pr-m dsg-clear-search-input">
      <div className="dsg-input-search-container">
        <SearchIcon className="search-icon" width="19px" height="19px" />
        <input
          type="search"
          enterKeyHint="search"
          id="searchInput"
          className="hmf-pl-xxs"
          name="search"
          ref={inputRef}
          autoCapitalize="off"
          autoComplete="off"
          spellCheck="false"
          autoCorrect="off"
          onClick={() => SearchInputActivatedEventEmitter()}
          onChange={(e) => updateSearchTerm(e)}
          // eslint-disable-next-line no-return-assign
          onKeyUp={(e) => searchKeydown(e)}
          placeholder="What are you looking for?"
          aria-label="Search"
          // onFocus={(event) => focusOnInput(event)}
          value={displayedSearchTerm}
        />
      </div>
      <div className="dsg-clear-container-old">
        <span
          className={searchInput?.length === 0 ? 'clear-input' : 'dsg-clear-button hmf-body-s'}
          onClick={(e) => handleClear(e)}
          onKeyDown={(e) => handleClear(e)}
          role="button"
          tabIndex={0}>
          Cancel
        </span>
        <span
          className={searchInput?.length === 0 ? 'clear-input' : ' hmf-ml-xs clear-forward-divider'}
        />
        <strong />
        <button
          className={searchInput?.length === 0 ? 'clear-input' : 'dsg-forward-logo'}
          onClick={() => {
            if (searchInput?.length !== 0) {
              window.location.href = submitSearch(searchInput, 'enterSearchTerm');
            }
          }}
          onKeyDown={(e) => searchKeydown(e)}
          type="button"
          aria-label="navigate to search results"
          tabIndex={0}>
          <HomefieldIconArrowRight className="search-forward-arrow" width="18px" height="18px" />
        </button>
      </div>
    </div>
  );

  const returnedProductJsx = (product: SearchProductResult) => (
    <SearchResults
      key={product.seoUrl}
      maxListPrice={product.maxListPrice}
      maxOfferPrice={product.maxOfferPrice}
      minListPrice={product.minListPrice}
      minOfferPrice={product.minOfferPrice}
      mapPriceIndicator={product.mapPriceIndicator}
      priceIndicator={product.priceIndicator}
      name={product.name}
      partNumber={product.partNumber}
      seoUrl={
        product.isPinned
          ? `${product.seoUrl}${
              product.seoUrl?.includes('Product=SuggestedPinnedProduct')
                ? ''
                : '?Product=SuggestedPinnedProduct'
            }`
          : `${product.seoUrl}${
              product.seoUrl?.includes('Product=ProductSuggest') ? '' : '?Product=ProductSuggest'
            }`
      }
      thumbnail={getProductImage(product)}
    />
  );

  const suggestedProductsJsx = (
    <div
      className="dsg-search-products-container hmf-pb-xs"
      ref={productsContainerRef}
      tabIndex={0}>
      <p className="dsg-search-top-products hmf-label-s hmf-pt-s hmf-pl-xs hmf-mb-xxs">
        Top Products
      </p>
      <div
        className="dsg-search-products"
        id={mobile ? 'dsg-search-products-mobile' : 'dsg-search-products-desktop'}>
        {Array.isArray(searchData?.products)
          ? searchData.products.map((product) => returnedProductJsx(product))
          : null}
      </div>
      <a
        className="dsg-search-view-all-results__link hmf-label-m hmf-mt-xxs hmf-mb-xxxs hmf-py-s hmf-px-xs hmf-display-block"
        href={checkStores(evaluateViewAllUrl())}
        tabIndex={0}>
        View All Results
      </a>
    </div>
  );

  const suggestedHeading = (term: string, results: any) => {
    return results[term].length > 0 ? <h1>{term}</h1> : '';
  };

  function CloseButton() {
    return (
      <div className="close-button-wrapper">
        <div
          className="close-button"
          role="button"
          onClick={() => setshowResultsDiv(false)}
          onMouseDown={(e) => e.preventDefault()}
          onKeyDown={(event) => {
            if (event.keyCode === KEY_CODES.SPACE) {
              setshowResultsDiv(false);
            }
          }}
          tabIndex={0}>
          <HomefieldIconSignCancel className="close-button-icon" width="23px" height="23px" />
          <span className="close-button__text hmf-subheader-bold-s hmf-m-xxs">Close</span>
        </div>
      </div>
    );
  }

  function ViewAllResultsButton() {
    return (
      <p className="dsg-search-view-all-results">
        <a
          className="dsg-search-view-all-results__link hmf-label-m hmf-pb-xxxs"
          href={checkStores(evaluateViewAllUrl())}>
          View All Results
        </a>
      </p>
    );
  }

  const getIdForSearchContainer = (element: string) => {
    return mobile ? `mobile-${element}-container` : `desktop-${element}-container`;
  };

  return (
    <div
      className={`search-bar-container ${
        mobile ? 'hmf-display-xlg-none' : 'hmf-display-none hmf-display-xlg-flex'
      } hmf-px-s hmf-px-md-m hmf-pt-s hmf-pt-xlg-0`}
      id={getIdForSearchContainer('search-bar')}>
      {mobile && (
        <>
          <div id="header-search-bar-sticky-anchor" />
          <div id="header-search-bar-sticky-ghost-div" />
        </>
      )}

      <div
        className={`header-search-bar search-${viewPortBreakpoint} ${
          mobile ? 'mobile-search-bar' : 'desktop-search-bar'
        } ${mobile && 'dsg-header-search-sticky-enabled'}
          ${!mobile && 'dsg-search-wrapper'}
        }`}>
        <div
          id="searchContent"
          ref={wrapperRef}
          className={showResultsDiv ? 'dsg-search-border dsg-search' : 'dsg-search'}
          role="menu"
          onKeyDown={(event) => {
            if (event.keyCode === KEY_CODES.ESCAPE) {
              handleClear(event);
            }
          }}>
          {showResultsDiv && (
            // eslint-disable-next-line jsx-a11y/control-has-associated-label
            <button
              type="button"
              tabIndex={0}
              className="search-backdrop hmf-position-absolute"
              onClick={() => setshowResultsDiv(false)}
              onKeyPress={(e) => handleADA(e, 'button', setshowResultsDiv(false))}
            />
          )}
          {searchInputJsx}
          {showResultsDiv &&
            searchData.suggestions &&
            searchInput &&
            searchInput.length > 2 &&
            searchHistoryResults.length === 0 && (
              <div
                data-testid="sayt-results-container"
                className="dsg-search-results-box"
                id={getIdForSearchContainer('sayt-results')}>
                {viewPortBreakpoint !== 'desktop' && <CloseButton />}
                <div className="dsg-search-result-products">
                  <div className="dsg-search-suggested-container" title="Suggested Keywords">
                    <div className="dsg-search-suggested-keywords">
                      {viewPortBreakpoint !== 'desktop' && (
                        <div className="top-suggestions hmf-subheader-bold-l hmf-display-flex hmf-align-items-center hmf-pl-s">
                          <span>Top Suggestions</span>
                        </div>
                      )}
                      <SuggestionKeywordsResults
                        suggestionResults={searchData.suggestions}
                        submitSearch={submitSearch}
                        searchTerm={searchInput}
                        setSearchTerm={setSearchInput}
                        searchFromSuggestion={searchFromSuggestion}
                        updateSearchTermSAYT={updateSearchTermSAYT}
                        clickSuggestedTerm={clickSuggestedTerm}
                        productsContainerRef={productsContainerRef}
                      />
                    </div>
                    {viewPortBreakpoint === 'mobile' && (
                      <div className="dsg-search-suggested-products" title="Suggested Products">
                        {suggestedHeading('products', searchData.suggestions)}
                        <SuggestionProductsResults
                          productResults={searchData.products}
                          clickSuggestedTerm={clickSuggestedTerm}
                        />
                      </div>
                    )}
                    <div className="dsg-search-suggested-categories" title="Suggested Categories">
                      {suggestedHeading('categories', searchData.suggestions)}
                      <SuggestionCategoriesResults
                        suggestionResults={searchData.suggestions}
                        submitSearch={submitSearch}
                        searchFromSuggestion={searchFromSuggestion}
                        clickSuggestedTerm={clickSuggestedTerm}
                      />
                    </div>
                    <div className="dsg-search-suggested-brands" title="Suggested Brands">
                      {suggestedHeading('brands', searchData.suggestions)}
                      <SuggestionBrandsResults
                        suggestionResults={searchData.suggestions}
                        submitSearch={submitSearch}
                        setSearchTerm={setSearchInput}
                        searchFromSuggestion={searchFromSuggestion}
                        clickSuggestedTerm={clickSuggestedTerm}
                      />
                    </div>
                  </div>
                  {viewPortBreakpoint !== 'mobile' && suggestedProductsJsx}
                </div>
                {viewPortBreakpoint === 'mobile' && <ViewAllResultsButton />}
              </div>
            )}
          {showResultsDiv &&
            searchHistoryResults &&
            searchHistoryResults.length > 0 &&
            searchInput?.length === 0 && (
              <div className="dsg-search-results-box">
                <div className="recent-search">
                  <h1 className="recent-search-heading">Recent Searches</h1>
                  <SuggestionHistoryResults
                    searchHistoryResults={searchHistoryResults}
                    searchFromSuggestion={searchFromSuggestion}
                    updateSearchTermSAYT={updateSearchTermSAYT}
                    submitSearch={submitSearch}
                    clickSuggestedTerm={clickSuggestedTerm}
                  />
                </div>
              </div>
            )}
        </div>
      </div>
    </div>
  );
}
